//IE old version tip
// var userAgent = window.navigator.userAgent;  
// if (userAgent.indexOf("MSIE 7.0")>0 || userAgent.indexOf("MSIE 8.0")>0 || userAgent.indexOf("MSIE 9.0")>0) {
//   	var url = "http://cybersoft.begonia.tw/browser.html";  
//   	setTimeout(
// 	  function(){
// 	    $(location).attr('href',url);
// 	  }, 0);
// }

(function($, window, document){

	// ----------------------------------- 
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws;

	// 取得Window設定值
	var windowSetting = function(){
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();

	
	// -----------------------------------
	// FastClick
	FastClick.attach(document.body);


	// -----------------------------------
	//go top
	var gotop = $("#gotop");

	gotop.on("click touchstart",function(){
		$('html, body').animate({
			scrollTop: 0
		}, 400, "swing");
	});


	// -----------------------------------
	// Loader 
	var loaderRemove = function(){
		$('#loader').fadeOut('1000',function(){
			$(this).remove();
		});
	}

	$('#menu-hamburger').on('click', function(){
		$(this).toggleClass('is-active');
		$('header').toggleClass('is-open');
	});

	function headerScrollSticky(){
		if(ws > 100){
			$('header').addClass('is-sticky');
		}else{
			$('header').removeClass('is-sticky');
		}
	}


	// Footer
	var footer = $('#footer');
	var rightFixed = $('.right-fixed');
	function footerFixedSticky(){
		if(ws + wh < footer.offset().top){
			rightFixed.addClass('is-sticky')
		}else{
			rightFixed.removeClass('is-sticky')
		}

		// Go Top
		if(ws > wh){
			rightFixed.removeClass('hide-gotop');
		}else{
			rightFixed.addClass('hide-gotop');
		}

		// Rigister
		if(ws + wh > $('#register').offset().top ){
			rightFixed.addClass('hide-register');
		}else{
			rightFixed.removeClass('hide-register');
		}
	}


	// --------------------------------------------
	// Select all links with hashes
	$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function(event) {
	// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
			&& 
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
			// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').stop().animate({
					scrollTop: target.offset().top
				}, 1000);

				if(ww < 640){
					$('#menu-hamburger').removeClass('is-active');
					$('header').removeClass('is-open');
				}
			}
		}
	});



	// --------------------------------------------
	var lastId,
		topMenu = $("[data-scroll-list]"),
		headerH = $('header').innerHeight(),
		// All list items
		menuItems = topMenu.find("a"),
		// Anchors corresponding to menu items
		scrollItems = menuItems.map(function () {
			var item = $($(this).attr("href"));
			if (item.length) {
				return item;
			}
		});


	// Bind to scroll
	var scrollSectionHandler = function(){

		
		// Get container scroll position
		var fromTop = $(this).scrollTop() + headerH;
		
		// Get id of current scroll item
		var cur = scrollItems.map(function () {
			if ($(this).offset().top < fromTop)
				return this;
		});
		// Get the id of the current element
		cur = cur[cur.length - 1];
		var id = cur && cur.length ? cur[0].id : "";

		if (lastId !== id) {
			lastId = id;
			// Set/remove active class

			menuItems
				.parent().removeClass("is-active")
				.end().filter("[href='#" + id + "']").parent().addClass("is-active");
		}
	}
	window.addEventListener('scroll', scrollSectionHandler);







	// --------------------------------------------
	// Swiper
	var SwiperItem1 = '#report-list-slider';
	var SwiperItem1__Pagination = $(SwiperItem1).parent().children('.swiper-pagination');
	var SwiperItem1__BtnNext = $(SwiperItem1).parent().children('.swiper-button-next');
	var SwiperItem1__BtnPrev = $(SwiperItem1).parent().children('.swiper-button-prev');
	var mySwiper1 = new Swiper( SwiperItem1, {
		speed: 400,
		slidesPerView: 3,
		slidesPerGroup: 3,
		navigation: {
			nextEl: SwiperItem1__BtnNext,
			prevEl: SwiperItem1__BtnPrev,
		},
		pagination: {
			el: SwiperItem1__Pagination,
			clickable: true,
			renderBullet: function (index, className) {
				var otherClass = '';
				if(index == this.pagination.perView)
					otherClass = ' bullet-extra'
				else if(index > this.pagination.perView)
					otherClass = ' bullet-hide'
				return '<span class="'+ className + otherClass + '"></span>';
			},
		},
		on: {
			init: function(){
				swiperBulletsAniInit(this);
			},
			slideChange: function(){
				swiperBulletsAni(this)
			},
			// lazyImageReady: detctedDevice
			// resize: mySwiperItem1_Resize
		},
		breakpoints: {
			// when window width is <= 640px
			1023: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
			// when window width is <= 640px
			639: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				autoHeight: true
			}
		}
	});
	// ---------------------------------------------------------
	// 動態隱藏Dot
	// 動態隱藏Dot - 要設置Init
	function swiperBulletsAniInit(item){
		if(item != undefined){
			item.activeIndexOld = 0;		// 用來記錄Old
			item.pagination.perView = 4;	// Pagination 最多一次顯示多少（不含縮小、被隱藏點）
		}
	}
	// 動態隱藏Dot - Change 事件
	function swiperBulletsAni(item){
		if(item != undefined){
			
			if(item.pagination.bullets == undefined || item.pagination.bullets.length <= 5) return false;

			var activeIndex = item.realIndex;
			var sliderBullets = item.pagination.bullets;
			var sliderLength = sliderBullets.length;
			var pagiPerView = item.pagination.perView;

			var thisBullet = sliderBullets[activeIndex];
			var dir = (activeIndex - item.activeIndexOld > 0) ? 'next' : 'prev';

			if(thisBullet != undefined){

				// 如果是有extra的
				if(thisBullet.className.match(/\bbullet-extra\b/) != null){
					thisBullet.classList.remove('bullet-extra');

					// 移除鄰近的 Hide Class
					var nearBullet = thisBullet.previousSibling
					if(dir == 'next'){
						nearBullet = thisBullet.nextSibling;
					}
					if(nearBullet != null){
						nearBullet.classList.remove('bullet-hide');
						nearBullet.classList.add('bullet-extra');
					}

					// 增加遠端的extra
					var farBullet = sliderBullets[activeIndex + pagiPerView];
					if(dir == 'next'){
						farBullet = sliderBullets[activeIndex - pagiPerView];
					}
					if(farBullet != null){
						farBullet.classList.remove('bullet-hide');
						farBullet.classList.add('bullet-extra');
					}

					// 增加遠端的hide
					var farfarBullet = sliderBullets[activeIndex + (pagiPerView + 1)];
					if(dir == 'next'){
						farfarBullet = sliderBullets[activeIndex - (pagiPerView + 1)];
					}
					if(farfarBullet != null){
						farfarBullet.classList.remove('bullet-extra');
						farfarBullet.classList.add('bullet-hide');
					}
				}else if(thisBullet.className.match(/\bbullet-hide\b/) != null){
					// 如果是Hide (因Loop產生)
					thisBullet.classList.remove('bullet-hide');

					for(var i = 1; i < sliderLength; i++){
						if(dir == 'next'){
							// 0 -> last : Next
							var farBullet = sliderBullets[activeIndex - i]
						}else{
							// last -> 0 : Prev
							var farBullet = sliderBullets[activeIndex + i]
						}
						if(i < pagiPerView){
							farBullet.classList.remove('bullet-extra');
							farBullet.classList.remove('bullet-hide');
						}else if( i == pagiPerView){
							farBullet.classList.add('bullet-extra');
							farBullet.classList.remove('bullet-hide');
						}else{
							farBullet.classList.remove('bullet-extra');
							farBullet.classList.add('bullet-hide');
						}
					}
				}
			}
			item.activeIndexOld = activeIndex;
		}
	}
	// -------------------------------------------





	// ----------------------------------- Window 相關監測
	// window on scroll use javascript
	// Reference: https://stackoverflow.com/a/10915048
	// http://dev.w3.org/2006/webapi/DOM-Level-3-Events/html/DOM3-Events.html#event-type-scroll
	function onScrollEventHandler(ev){
		ws = win.scrollTop();
		headerScrollSticky();
		footerFixedSticky();
	}
	function onResizeEventHandler(ev){
		windowSetting();
	}
	function onLoadEventHandler(ev){
		loaderRemove();
		headerScrollSticky();
		footerFixedSticky();
	}

	if(w.addEventListener){
		w.addEventListener('scroll', onScrollEventHandler, false);   
		w.addEventListener('resize', onResizeEventHandler, false);   
		w.addEventListener('load', onLoadEventHandler, false);   
	} else if (w.attachEvent){
		w.attachEvent('onscroll', onScrollEventHandler); 
		w.attachEvent('onresize', onScrollEventHandler); 
		w.attachEvent('load', onLoadEventHandler); 
	}

})(jQuery, window, document);